/* src/app/forms/products-download/products-download-task-processor/products-download-task-processor.component.scss */
.mat-mdc-form-field {
  display: inline;
  overflow: auto;
  height: 100%;
}
textarea {
  height: 100% !important;
  overflow: auto;
  width: 100%;
  font-size: 10px;
}
:host ::ng-deep .customtextarea {
}
:host ::ng-deep .customtextarea .mat-form-field-flex {
  height: 100% !important;
}
:host ::ng-deep .customtextarea .mat-form-field-infix {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-flex {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-wrapper {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-infix {
  height: 100% !important;
}
.pb-content {
  margin-bottom: 10px;
}
.content {
  height: 400px;
  width: 100%;
  display: flex;
  padding: 10px;
  flex-direction: column;
}
.text-content {
  height: 100%;
  width: 100%;
}
.customtextarea {
  height: 100%;
}
.mat-mdc-raised-button {
  padding: 0 15px;
  font-size: 0.8em;
  line-height: 24px !important;
}
/*# sourceMappingURL=products-download-task-processor.component.css.map */
